export class WorkItemNotAvailableForAssignment {       
}